/* CAFFREY Maestro — page behaviour. v2 (Claude Code, launch BUILDER, workflow A4, 2026-10-08).
   Same behaviour as the sister insole pages (Walk On Air v3 / Comfort Max / Odour Smart), Maestro's own elements:
   <cf-mst2-gallery>  three studio photos in one square frame: arrows + facet dots SLIDE them (animated); swipe, arrow keys.
   <cf-mst2-buy>      plain EU size radios -> the form's hidden [name=id] (+ bubbling change, KIT.md §4a), price, Add to cart
                      state, ?variant= URL, quantity stepper, size-table highlight, the size-chart sheet. Nothing is
                      preselected: Add to cart, Shop Pay (guard) and the kit sticky bar ask for a size first.
   <cf-mst2-stage>    "Support, dressed in cow leather.": every numbered disc and every chip opens its own card.
   Lazy images        img[data-mst-src] outside the hero load ~600 px before they scroll in; hero photos 2-3 after load.
   Safe to load more than once (defer). No dependencies. prefers-reduced-motion: no slide, no smooth scroll. */
(function () {
  if (window.CfMstPage) return;
  window.CfMstPage = true;

  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced() { return !!(mq && mq.matches); }
  function designMode() { return !!(window.Shopify && window.Shopify.designMode); }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function swapIn(img) { /* srcset before src: one download, the right width */
    if (!img.hasAttribute('data-mst-src')) return;
    var set = img.getAttribute('data-mst-srcset');
    if (set) img.setAttribute('srcset', set);
    img.setAttribute('src', img.getAttribute('data-mst-src'));
    img.removeAttribute('data-mst-src');
    img.removeAttribute('data-mst-srcset');
  }

  /* Alex (Walk On Air, 2026-10-07; same on every insole page): no Klaviyo pop-up here (hidden in cf-mst-v2.css). Klaviyo
     still adds its scroll lock to <body> while it thinks the pop-up is open, so release it whenever it appears. */
  (function () {
    var b = document.body;
    if (!b) return;
    var free = function () { if (b.classList.contains('klaviyo-prevent-body-scrolling')) b.classList.remove('klaviyo-prevent-body-scrolling'); };
    free();
    if ('MutationObserver' in window) new MutationObserver(free).observe(b, { attributes: true, attributeFilter: ['class'] });
  })();

  /* ---------------- lazy images below the fold (stage, close-ups) ---------------- */
  function lazyBelow() {
    var imgs = Array.prototype.slice.call(document.querySelectorAll('img[data-mst-src]')).filter(function (img) {
      return !img.closest('cf-mst2-gallery');
    });
    if (!imgs.length) return;
    if (!('IntersectionObserver' in window)) { imgs.forEach(swapIn); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        swapIn(en.target);
        io.unobserve(en.target);
      });
    }, { rootMargin: '600px 0px 600px 0px' });
    imgs.forEach(function (img) { io.observe(img); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lazyBelow, { once: true }); else lazyBelow();

  /* ---------------- gallery: arrows + facet dots over a snapping strip ---------------- */
  class MstGallery extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      this.track = this.querySelector('[data-mst-slides]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-mst-slide]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-mst-dot]'));
      if (!this.track || this.slides.length < 2) return;
      this.index = 0;
      this.setAttribute('data-enhanced', '');
      var prev = this.querySelector('[data-mst-prev]');
      var next = this.querySelector('[data-mst-next]');
      if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); });
      if (next) next.addEventListener('click', function () { self.go(self.index + 1); });
      this.dots.forEach(function (d, i) { d.addEventListener('click', function () { self.go(i); }); });
      this.track.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        self.go(self.index + (e.key === 'ArrowRight' ? 1 : -1));
      });
      var ticking = false;
      this.track.addEventListener('scroll', function () {
        if (ticking || self._raf) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var w = self.track.clientWidth || 1;
          self.mark(Math.round(self.track.scrollLeft / w));
        });
      }, { passive: true });
      /* photos 2-3: fetched once the page has loaded (or at the first touch of the gallery), so a tap never shows a gap */
      var warm = function () { self.slides.forEach(function (s) { var img = s.querySelector('img[data-mst-src]'); if (img) swapIn(img); }); };
      if (document.readyState === 'complete') setTimeout(warm, 300); else window.addEventListener('load', function () { setTimeout(warm, 300); }, { once: true });
      ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) { self.addEventListener(ev, warm, { once: true, passive: true }); });
    }
    /* the photo visibly slides (ease-out ~0.5 s) with snapping paused until it lands; reduced motion: instant */
    go(i) {
      var n = this.slides.length;
      i = ((i % n) + n) % n;
      this.mark(i);
      var self = this, track = this.track;
      var from = track.scrollLeft, to = i * track.clientWidth;
      if (this._raf) { cancelAnimationFrame(this._raf); this._raf = null; }
      if (reduced() || Math.abs(to - from) < 2) { track.scrollLeft = to; return; }
      var dur = Math.min(900, 480 + 120 * Math.abs(to - from) / (track.clientWidth || 1));
      var t0 = null;
      track.style.scrollSnapType = 'none';
      var step = function (ts) {
        if (t0 === null) t0 = ts;
        var t = Math.min(1, (ts - t0) / dur);
        var e = 1 - Math.pow(1 - t, 3);
        track.scrollLeft = from + (to - from) * e;
        if (t < 1) { self._raf = requestAnimationFrame(step); return; }
        self._raf = null;
        track.scrollLeft = to;
        track.style.scrollSnapType = '';
      };
      this._raf = requestAnimationFrame(step);
    }
    mark(i) {
      if (i === this.index && this._marked) return;
      this._marked = true;
      this.index = Math.max(0, Math.min(this.slides.length - 1, i));
      var k = this.index;
      this.dots.forEach(function (d, j) { d.setAttribute('aria-current', String(j === k)); });
    }
  }

  /* ---------------- buy box: size radios -> kit-compatible product form ----------------
     No size is preselected: only the shopper or a ?variant= link chooses one. Until then the main "Add to cart" asks for a
     size (message under the sizes, scroll, focus); Shop Pay is covered by a transparent guard button that asks too
     (Shopify greys its button while the form has no id, and a disabled button fires no click); the kit sticky bar reads
     "Choose your size" with an active "Add to cart" that presses the main button. */
  class MstBuy extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      this.form = document.getElementById(this.dataset.form);
      if (!this.form) return;
      this.idInput = this.form.querySelector('input[type="hidden"][name="id"]');
      if (this.idInput) this.idInput.disabled = false; /* disabled in the HTML so no-JS shoppers use the <noscript> select */
      this.atc = this.form.querySelector('[data-cf-atc]');
      this.atcLabel = this.atc ? this.atc.querySelector('span') : null;
      this.qty = this.form.querySelector('input[name="quantity"]');
      this.msg = this.querySelector('[data-mst-size-msg]');
      this.sizes = this.querySelector('[data-mst-sizes]');
      this.guard = this.querySelector('[data-mst-pay-guard]');
      this.radios = Array.prototype.slice.call(this.querySelectorAll('input[data-mst-size]'));
      this.addEventListener('change', function (e) {
        if (e.target.matches && e.target.matches('input[data-mst-size]')) self.select(e.target, true);
      });
      this.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-mst-qty]');
        if (!b || !self.qty) return;
        var min = parseInt(self.qty.min, 10) || 1;
        self.qty.value = Math.max(min, (parseInt(self.qty.value, 10) || min) + Number(b.getAttribute('data-mst-qty')));
        self.qty.dispatchEvent(new Event('change', { bubbles: true }));
      });
      /* Capture phase on an ancestor of the form: runs before Dawn's <product-form> submit handler on the form. */
      this.addEventListener('submit', function (e) {
        if (e.target !== self.form || self.current()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        self.ask();
      }, true);
      if (this.guard) this.guard.addEventListener('click', function (e) { e.preventDefault(); self.ask(); });
      /* Keyboard users can still reach Shopify's "More payment options" link under the guard: with no size chosen, a click
         anywhere in the payment block asks for a size instead. */
      var pay = this.querySelector('[data-mst-pay]');
      if (pay) pay.addEventListener('click', function (e) {
        if (self.current() || (e.target.closest && e.target.closest('[data-mst-pay-guard]'))) return;
        e.preventDefault();
        e.stopPropagation();
        self.ask();
      }, true);
      this.chart();
      window.addEventListener('pageshow', function () { self.sync(); });
      this.sync();
      this.watchSticky();
    }
    /* "Size chart" opens the chart right here (a sheet), cloned from the Description's Size chart row; without <dialog>
       support (or without that section) the link simply jumps to the row (opened, below). */
    chart() {
      var self = this;
      var open = this.querySelector('[data-mst-chart-open]');
      var dlg = document.querySelector('[data-mst-chart-dialog]');
      if (!open || !dlg || typeof dlg.showModal !== 'function') return;
      open.addEventListener('click', function (e) {
        if (!self.fillChart(dlg)) return;
        e.preventDefault();
        self._chartTrigger = open;
        dlg.showModal();
        var r = self.current();
        self.highlight(r ? r.getAttribute('data-title') : null);
      });
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg || (e.target.closest && e.target.closest('[data-mst-chart-close]'))) dlg.close();
      });
      dlg.addEventListener('close', function () { if (self._chartTrigger) self._chartTrigger.focus(); });
    }
    fillChart(dlg) {
      var slot = dlg.querySelector('[data-mst-chart-slot]');
      if (!slot) return false;
      if (slot.childElementCount) return true;
      var src = document.querySelector('[data-mst-chart-src]');
      if (!src) return false;
      var c = src.cloneNode(true);
      c.removeAttribute('data-mst-chart-src');
      slot.appendChild(c);
      return true;
    }
    current() {
      for (var i = 0; i < this.radios.length; i++) if (this.radios[i].checked) return this.radios[i];
      return null;
    }
    firstAvailable() {
      for (var i = 0; i < this.radios.length; i++) if (this.radios[i].getAttribute('data-available') === 'true') return this.radios[i];
      return null;
    }
    sync() {
      var r = this.current();
      if (r) this.select(r, false); else this.none();
    }
    setId(value) {
      if (this.idInput && this.idInput.value !== value) {
        this.idInput.value = value;
        this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    highlight(title) {
      each(document.querySelectorAll('[data-mst-row]'), function (tr) {
        tr.classList.toggle('is-current', title !== null && tr.getAttribute('data-mst-row') === title);
      });
    }
    none() {
      var any = !!this.firstAvailable();
      this.setId('');
      this.highlight(null);
      if (this.atc) {
        this.atc.disabled = !any;
        if (this.atcLabel) this.atcLabel.textContent = any ? this.dataset.add : this.dataset.soldOut;
      }
      if (this.guard) this.guard.hidden = !any;
      this.patchSticky();
    }
    select(r, byUser) {
      var available = r.getAttribute('data-available') === 'true';
      this.setId(r.value);
      var price = r.getAttribute('data-price');
      if (price) each(document.querySelectorAll('[data-mst-price]'), function (el) { el.textContent = price; });
      this.highlight(r.getAttribute('data-title'));
      if (this.atc) {
        this.atc.disabled = !available;
        if (this.atcLabel) this.atcLabel.textContent = available ? this.dataset.add : this.dataset.soldOut;
      }
      if (this.guard) this.guard.hidden = true;
      this.clearAsk();
      this.patchSticky();
      if (byUser && !designMode() && window.history && history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', r.value);
          history.replaceState(history.state, '', u.toString());
        } catch (e) { /* ignore */ }
      }
    }
    /* "Choose your size first.": message under the sizes, sizes highlighted, scrolled into view, first size focused. */
    ask() {
      var first = this.firstAvailable();
      var st = document.querySelector('cf-kit-sticky');
      if (st && typeof st.done === 'function') st.done();
      if (!first) return;
      if (this.msg) {
        this.msg.textContent = this.dataset.sizeError || '';
        this.msg.hidden = false;
      }
      if (this.sizes) {
        this.sizes.classList.remove('is-asking');
        void this.sizes.offsetWidth; /* restart the highlight when asked again */
        this.sizes.classList.add('is-asking');
        var box = this.sizes.getBoundingClientRect();
        if (box.top < 72 || box.bottom > window.innerHeight - 96) {
          this.sizes.scrollIntoView({ block: 'center', behavior: reduced() ? 'auto' : 'smooth' });
        }
      }
      try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
    }
    clearAsk() {
      if (this.msg && !this.msg.hidden) { this.msg.hidden = true; this.msg.textContent = ''; }
      if (this.sizes) this.sizes.classList.remove('is-asking');
    }
    /* The kit sticky bar (cf-kit-sticky, shared) mirrors the form's id: with none it reads "Unavailable". */
    watchSticky() {
      var self = this;
      var tries = 0;
      var attach = function () {
        var st = document.querySelector('cf-kit-sticky');
        if (!st) { if (++tries < 40) setTimeout(attach, 250); return; }
        if (self._stObs) return;
        self._st = st;
        self._stObs = new MutationObserver(function () { self.patchSticky(); });
        self._stObs.observe(st, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
        self.patchSticky();
      };
      attach();
    }
    patchSticky() {
      var st = this._st;
      if (!st) return;
      var btn = st.querySelector('[data-cf-sticky-atc]');
      var label = btn ? btn.querySelector('span') : null;
      var v = st.querySelector('[data-cf-sticky-variant]');
      var r = this.current();
      if (r) {
        var want = (this.dataset.prefix || '') + (r.getAttribute('data-label') || r.getAttribute('data-title') || '');
        if (v && v.textContent !== want) v.textContent = want;
        return; /* availability: the kit's own sync */
      }
      if (!this.firstAvailable()) return; /* nothing in stock: keep the kit's sold-out state */
      if (btn && btn.disabled) btn.disabled = false;
      if (label && label.textContent !== this.dataset.add) label.textContent = this.dataset.add;
      if (v && v.textContent !== this.dataset.choose) v.textContent = this.dataset.choose;
    }
  }

  /* ---------------- "Support, dressed in cow leather." — numbered as on the carton back ---------------- */
  class MstStage extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      this.discs = Array.prototype.slice.call(this.querySelectorAll('.cf-mst2-disc[data-mst-part]'));
      this.chips = Array.prototype.slice.call(this.querySelectorAll('.cf-mst2-chip[data-mst-part]'));
      this.leads = Array.prototype.slice.call(this.querySelectorAll('[data-mst-lead]'));
      this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-mst-panel]'));
      if (!this.chips.length || !this.panels.length) return;
      this.setAttribute('data-enhanced', '');
      var group = this.querySelector('[data-mst-chips]');
      if (group) group.hidden = false;
      var hint = this.querySelector('[data-mst-hint]');
      if (hint) hint.hidden = false;
      this.discs.concat(this.chips).forEach(function (t) {
        t.addEventListener('click', function () { self.show(t.getAttribute('data-mst-part'), true); });
      });
      this.chips.forEach(function (c, i) {
        c.addEventListener('keydown', function (e) {
          if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(e.key) < 0) return;
          e.preventDefault();
          var n = self.chips.length;
          var j = e.key === 'Home' ? 0 : e.key === 'End' ? n - 1 : (i + (e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : -1) + n) % n;
          self.show(self.chips[j].getAttribute('data-mst-part'), true);
          self.chips[j].focus();
        });
      });
      this.show(this.getAttribute('data-part') || '4');
    }
    show(part, reveal) {
      if (!part) return;
      this.setAttribute('data-part', part);
      this.chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c.getAttribute('data-mst-part') === part)); });
      this.discs.forEach(function (d) { d.toggleAttribute('data-on', d.getAttribute('data-mst-part') === part); });
      this.leads.forEach(function (l) { l.toggleAttribute('data-on', l.getAttribute('data-mst-lead') === part); });
      this.panels.forEach(function (p) { p.hidden = p.getAttribute('data-mst-panel') !== part; });
      if (reveal) this.reveal();
    }
    /* A tap must change text the shopper can see (fixer, 2026-10-08). The card sits right under the photo (CSS); if it is
       still under the kit sticky bar, off screen or under the returning header, scroll the least distance that shows it
       whole. Only after a tap or arrow key, never on load; instant with reduced motion. */
    reveal() {
      var card = this.querySelector('.cf-mst2-card');
      if (!card) return;
      requestAnimationFrame(function () {
        var r = card.getBoundingClientRect();
        if (!r.height) return;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var pad = 16;
        var bottom = vh;
        var bar = document.querySelector('.cf-kit-sticky.is-visible');
        if (bar && getComputedStyle(bar).display !== 'none') bottom -= bar.offsetHeight;
        var head = document.querySelector('.section-header');
        var headNow = head ? Math.max(0, Math.min(head.getBoundingClientRect().bottom, vh / 3)) : 0; /* over the page now */
        var headUp = head ? Math.min(head.offsetHeight, vh / 3) : 0; /* the on-scroll-up header returns when the page scrolls up */
        if (r.top >= headNow && r.bottom <= bottom) return; /* already whole on screen: never move the page */
        var dy = r.top < headNow ? r.top - (headUp + pad) : Math.min(r.bottom - (bottom - pad), r.top - (headNow + pad));
        if (Math.abs(dy) < 2) return;
        window.scrollBy({ top: dy, left: 0, behavior: reduced() ? 'auto' : 'smooth' });
      });
    }
  }

  /* Any #cf-mst2-size link (except the sheet button) opens the Description's Size chart row. */
  (function () {
    var openRow = function () { var d = document.querySelector('[data-mst-size-row]'); if (d) { var parent = d.closest('.cf-mst2-details-main'); if (parent) parent.open = true; d.open = true; } };
    if (window.location.hash === '#cf-mst2-size') openRow();
    window.addEventListener('hashchange', function () { if (window.location.hash === '#cf-mst2-size') openRow(); });
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href="#cf-mst2-size"]');
      if (a && !a.hasAttribute('data-mst-chart-open')) openRow();
    });
  })();

  [['cf-mst2-gallery', MstGallery], ['cf-mst2-buy', MstBuy], ['cf-mst2-stage', MstStage]].forEach(function (d) {
    if (!customElements.get(d[0])) customElements.define(d[0], d[1]);
  });
})();
